import { TLC_CONSTANTS } from "../../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { LS2PAC_Utils } from "../../utils/Utils";
import { BatchDialogView } from "../BatchDialogView";
import { BulkActionControl } from "../../controls/BulkActionControl";

export class BaseResultsView extends BatchDialogView {
  constructor(options) {
    super(
      $.extend(true, {}, options, {
        selectAllContainerId: "checkAllResultsContainer",
        itemsId: LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsContainer,
        itemClass: "checkboxHolder",
        resetCheckboxes: false,
      })
    );

    //need to set page data and fieldName
    this.id = LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsContainer;
    this.tmpl = options.tmpl;
    this.errorAndSpellingTmpl = options.errorTmpl;

    this.databaseConfig = options.databaseConfig;
    this.containerId =
      this.databaseConfig.databaseKey +
      LS2PAC_CONSTANTS.Ids.SearchPage.resultsContentSuffix;
    this.resultsId =
      this.databaseConfig.databaseKey +
      LS2PAC_CONSTANTS.Ids.SearchPage.resultsListSuffix;

    this.hasBoundEvents = false;
    this.searchResponse;
    this.resultTypeViews = [];
    this.hasBoundEvents = false;
    this.spinnerTimeoutId = null;
    this.addListeners();
  }
  render(event, onChangeViewEvent) {
    var _this = this;
    var isCurrent = LS2PacSearchDatabaseManager.isCurrentDatabase(
      event.data.databaseKey
    );

    if (!isCurrent) {
      return;
    }
    if ($("#" + this.containerId).length === 0) {
      TemplateEngine.fetch(
        this.tmpl,
        $("#" + this.id),
        {
          databaseKey: this.databaseConfig.databaseKey,
        },
        function () {
          _this.addViewTypeClass(ApplicationData.getCurrentResultsView());
          _this.loadResults(event, onChangeViewEvent);
          _this.addEvents();
          _this.addBulkActions();
        }
      );
    } else {
      $("#" + this.containerId).show();
      this.loadResults(event, onChangeViewEvent);
    }
  }
  loadResults(event, onChangeViewEvent) {}
  createResultTypeViews() {}
  isCurrent() {
    return LS2PacSearchDatabaseManager.isCurrentDatabase(
      this.databaseConfig.databaseKey
    );
  }
  hide() {
    $("#" + this.containerId).hide();
  }
  show() {
    $("#" + this.containerId).show();
  }
  addExtraListeners() {}
  showError(message, suggestions) {
    if (this.isCurrent()) {
      suggestions = suggestions || [];
      $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsAreaContainer
      ).hide();
      var container = $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchErrorContainer
      );
      TemplateEngine.fetch(
        this.errorAndSpellingTmpl,
        container,
        { message: message, suggestions: suggestions },
        function () {
          container.show();
        },
        TemplateEngine.method.overwrite
      );
    }
  }
  hideError() {
    if (this.isCurrent()) {
      $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsAreaContainer
      ).show();
      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchErrorContainer).hide();
    }
  }
  addEvents() {
    if (this.hasBoundEvents == false) {
      $.each(this.resultTypeViews, function (index, view) {
        view.addEvents();
      });

      this.addEventHandler($("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchErrorContainer), "click", ".titleSearch", (event) => {
        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSearch, {
          searchString: $(event.currentTarget).attr("data-term"),
        });
        return false;
      });

      this.setupCheckboxDelegation();
      this.hasBoundEvents = true;
    }
  }

  addViewTypeClass(viewName) {
    var container = $("#" + this.containerId);
    if (container.length > 0) {
      //we need to override the class thats there, not just add it
      container.get(0).className = viewName;
    }
    $(document.body).get(0).className = viewName;
  }
  handleSuggestions(event) {
    this.addEvents();

    if (LS2PAC_Utils.isSearchTermAnObject(event.term)) {
      this.showError(ApplicationData.language.searchErrorMessage);
    } else {
      if (event.success && event.suggestions && event.suggestions.length > 0) {
        this.showError(
          ApplicationData.language.noResultsFound + ' "' + event.term + '".',
          event.suggestions
        );
      } else {
        this.showError(
          ApplicationData.language.noResultsFound +
            ' "' +
            event.term +
            '". ' +
            ApplicationData.language.tryAgain
        );
      }
    }
  }
  handleSpinner() {
    this.waitingOnResults = true;
    $("#" + this.resultsId).empty();
    if (this.isCurrent() && this.waitingOnResults) {
      var container = $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsContainer
      );
      container.css("minHeight", "200px");
      if (window.isIE8 == false) {
        if(this.spinnerTimeoutId){
          clearTimeout(this.spinnerTimeoutId)
        }
        this.spinnerTimeoutId = setTimeout(function () {
          container.spin("large");
        }, 50);
      }
    }
  }
  togglePageElements() {
    if (this.databaseConfig.hasSaveSearch) {
      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.saveSearchButtonContainer).show();
    } else {
      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.saveSearchButtonContainer).hide();
    }

    if (this.databaseConfig.hideSearchTerm) {
      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTermContainer).hide();
    } else {
      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTermContainer).show();
    }

    if (
      this.databaseConfig.databaseKey ==
      LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.reserves.key
    ) {
      $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.reservesSearchTermContainer
      ).show();
    } else {
      $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.reservesSearchTermContainer
      ).hide();
    }

    if (this.databaseConfig.isBatchable) {
      $("#checkAllResultsContainer").show();
      BulkActionControl.show();
    } else {
      $("#checkAllResultsContainer").hide();
      BulkActionControl.hide();
    }
  }
  addListeners() {
    var _this = this;

    this.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.hide();
        _this.searchResponse = undefined;
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase,
      function (event) {
        if (_this.isCurrent() == false) {
          _this.hide();
        } else {
          _this.show();

          _this.togglePageElements();
        }
        _this.handleSpinner();
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (event) {
        _this.handleSpinner();
        if (_this.isCurrent()) {
          _this.togglePageElements();
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onChangeWorldBookDatabase,
      function (event) {
        _this.handleSpinner();
        if (_this.isCurrent()) {
          _this.togglePageElements();
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onLoginResponse,
      function (event) {
        if (event.success) {
          if (
            $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchPageView).is(
              ":visible"
            )
          ) {
            $.each(_this.resultTypeViews, function (index, view) {
              view.refreshAvailability();
            });
          }
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      function (event) {
        if (_this.isCurrent()) {
          _this.togglePageElements();
        }
      }
    );

    this.addListener(
      TLC_CONSTANTS.Events.onPagingModelResponse,
      function (event) {
        _this.waitingOnResults = false;
        
        if (_this.isCurrent()) {
          $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsContainer).spin(
            false
          );
          _this.uncheckSelectAll();
          if (event.success) {
            if (event.data.resources && event.data.resources.length === 0) {
              if (event.data.isAdvanced === true) {
                _this.showError(ApplicationData.language.searchErrorMessage);
              } else {
                TLCEventManager.fireEvent(
                  LS2PAC_CONSTANTS.Events.onGetSpellingSuggestions
                );
              }
              return;
            }
            _this.searchResponse = event;
            _this.hideError();
            _this.render(event);
          } else {
            _this.showError(ApplicationData.language.searchErrorMessage);
          }
        } else {
          _this.hide();
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onGetSpellingSuggestionsResponse,
      function (event) {
        _this.handleSuggestions(event);
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onBackToSearch,
      function (event) {
        if (_this.isCurrent()) {
          setTimeout(function () {
            _this.uncheckSelectAll();
            BulkActionControl.disable();
            _this.render(_this.searchResponse);
          }, 10);
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onChangeResultsView,
      function (event) {
        if (_this.isCurrent()) {
          _this.addViewTypeClass(event.viewName);
          if (_this.searchResponse) {
            $.each(_this.resultTypeViews, function (index, view) {
              view.clearResults();
            });
            if (event.viewName == "flowView") {
              _this.render(_this.searchResponse, true);
            }
          }
        }
      }
    );
  }

  cleanup() {
    super.cleanup();
    $.each(this.resultTypeViews, function (index, view) {
      if(view.cleanup){
        view.cleanup();
      }
    });
    this.hasBoundEvents = false;
    BulkActionControl?.cleanup();
  }
  //TODO feel like this stuff should really be in ListView...however there is no support for multiple inheritance
  getDataItemFromIndex(element) {
    if (this.isCurrent()) {
      var itemIndex = this.getItemIndex(element);
      return this.searchResponse.data.resources[itemIndex];
    }
  }
  toggleButtonsBasedOnCheckboxes() {
    var _this = this;
    if (this.isCurrent()) {
      //this timeout is silly but we have to wait for the UI to update when you un-select all
      setTimeout(function () {
        if ($("#" + _this.id).find("input:checked").length === 0) {
          BulkActionControl.disable();
        } else {
          BulkActionControl.enable();
        }
      }, 150);
    }
  }
  addBulkActions(event, onChangeViewEvent) {
    var _this = this;
    BulkActionControl.init([
      {
        text: ApplicationData.language.selectBulkAction,
        value: "",
      },
      {
        text: ApplicationData.language.placeARequest,
        value: LS2PAC_CONSTANTS.BulkActionTypes.Request.key,
        onChange: function () {
          var resources = _this.getSelectedItems();

          _this.openBatchDialog(
            {
              event: { resources: resources },
              batchErrorMessage:
                ApplicationData.language
                  .eResourcePlaceHoldAttemptWhenAvailableMessage,
              secondaryErrorMessage:
                ApplicationData.language
                  .eResourcePlaceHoldAttemptAllOthersMessage,
            },
            function (successfulItems) {
              if (_this.successfulItems.length > 0) {
                TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onRequest, {
                  resource: _this.successfulItems,
                  referrer: "BatchResults",
                  closeCallback: function () {
                    BulkActionControl.reset();
                  },
                });
              } else {
                BulkActionControl.reset();
              }
            }
          );
          // Open dialog -- available eBooks cannot be placed on hold -<br>- All other holds will be placed.  Select OK to continue -- OK/Cancel
        },
        localConfigCheck: function () {
          return LS2PAC_Utils.showBulkRequestOption();
        },
      },
      {
        text: ApplicationData.language.addToList,
        value: LS2PAC_CONSTANTS.BulkActionTypes.AddToList.key,
        onChange: function (event) {
          var resourceIds = [];
          //extract the id's
          if (_this.searchResponse) {
            $.each(_this.getSelectedItems(), function (index, resource) {
              resourceIds.push(resource.id);
            });
            TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onOpenAddToList, {
              resourceIds: resourceIds,
              element: $(event.currentTarget),
              closeCallback: function () {
                BulkActionControl.reset();
              },
            });
          }
          BulkActionControl.reset();
        },
      },
    ]);
  }
  splitResults(event) {
    var _this = this;

    _this.errors = [];
    _this.successfulItems = [];

    $.each(event.resources, function (index, item) {
      if (item.downloadable && item.availability) {
        _this.errors.push(item);
      } else {
        _this.successfulItems.push(item);
      }
    });
  }
  getResponseStringById(resource) {
    return resource.shortTitle;
  }
}
